module.exports = __webpack_public_path__ + "img/q_47_sor.6264d6fd.png";